import React from 'react'
import styles from './styles.module.css'

const Selector = ({ children }: any) => (
  <div className='mx-auto w-full border-b border-gray-100 px-4 py-5'>
    <div className='flex items-center space-x-4 '>
      <div className='flex-1 space-y-4 py-1'>
        <div className='space-y-2'>{children}</div>
      </div>
      <div className='h-6 w-6 rounded-full bg-gray-200 bg-opacity-60' />
    </div>
  </div>
)

export default function DetailsDataSkeleton() {
  return (
    <div className={styles['th-details']}>
      <div className={styles['th-shim-details']}>
        <Selector>
          <div className='h-4 w-1/3 rounded bg-gray-200 bg-opacity-60' />
          <div className='h-3 w-11/12 rounded bg-gray-200 bg-opacity-60' />
        </Selector>

        <Selector>
          <div className='h-4 w-1/3 rounded bg-gray-200 bg-opacity-60' />
          <div className='h-3 w-8/12 rounded bg-gray-200 bg-opacity-60' />
        </Selector>

        <Selector>
          <div className='h-4 w-28 rounded bg-gray-200 bg-opacity-60' />
          <div className='h-3 w-7/12 rounded bg-gray-200 bg-opacity-60' />
        </Selector>

        <Selector>
          <div className='h-4 w-1/4 rounded bg-gray-200 bg-opacity-60' />
          <div className='h-3 w-4/12 rounded bg-gray-200 bg-opacity-60' />
        </Selector>

        <Selector>
          <div className='h-4 w-1/3 rounded bg-gray-200 bg-opacity-60' />
          <div className='h-3 w-5/12 rounded bg-gray-200 bg-opacity-60' />
        </Selector>
      </div>
    </div>
  )
}
